import { render, staticRenderFns } from "./leaderViewData.vue?vue&type=template&id=0968c04e&scoped=true"
import script from "./leaderViewData.vue?vue&type=script&lang=js"
export * from "./leaderViewData.vue?vue&type=script&lang=js"
import style0 from "./leaderViewData.vue?vue&type=style&index=0&id=0968c04e&lang=css"
import style1 from "./leaderViewData.vue?vue&type=style&index=1&id=0968c04e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0968c04e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0968c04e')) {
      api.createRecord('0968c04e', component.options)
    } else {
      api.reload('0968c04e', component.options)
    }
    module.hot.accept("./leaderViewData.vue?vue&type=template&id=0968c04e&scoped=true", function () {
      api.rerender('0968c04e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/leaderViewData.vue"
export default component.exports